import { apiClient } from "../apiClient"
import { apiConnector } from "../apiConnector"
//import toast from "react-hot-toast"
export function Post_Contact(formData){
    return async(dispatch)=>{
        try {
            const response = await apiConnector("POST",apiClient.POST_CONTACT,formData)
            if(!response?.data?.success){
                throw new Error(response?.data?.message)
            }
            return response?.data
            //toast.success(response?.data?.message)
        } catch (error) {
            const message = error.response?.data?.message||error?.message
            console.log("Internal Client Error:",message)
            return error?.response?.data
        }
    }
}
